module.exports = {
    getRouteName(url) {
        if (typeof url === 'string') {
            const serviceName = url.split('/')[1];

            return serviceName;
        }
        return '';
    },
    cutPlural(name = '') {
        if (name === 'entities') {
            return 'entity';
        }
        if (name === 'pharmacies') {
            return 'pharmacy';
        }
        return name.slice(0, -1);
    }
}
